import m from "../../geodata/es2015/puertoRicoHigh";
window.am4geodata_puertoRicoHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/puertoRicoHigh.js
// module id = null
// module chunks = 